'use client';

import { CAPABILITIES, type Capability } from './capabilities';
import { useRuntime } from './RuntimeContext';

/**
 * Returns true if the current runtime has the named capability.
 *
 * Reads `useRuntime()` (server-seeded, never flips after hydration) and
 * looks up the static `CAPABILITIES` table. Safe to call during render.
 */
export function useCapability(cap: Capability): boolean {
  const runtime = useRuntime();
  return CAPABILITIES[runtime].has(cap);
}
